export default "__VITE_ASSET__Co88nmtI__"